import React from "react";
import "./BroadcastStreamingContainer.scss";
import "../../streaming/mobile.scss";
import { selectIsMobile } from "modules/deviceInfo";
import { useSelector } from "react-redux";

interface IBroadcastStreamingContainerProps {
  children: React.ReactNode;
}

const BroadcastStreamingContainer = ({
  children,
}: IBroadcastStreamingContainerProps) => {
  const isMobileView = useSelector(selectIsMobile);

  const mobileClass = isMobileView ? "mobile" : "";

  return (
    <div
      data-testid="broadcast-streaming-container"
      className={`broadcast-streaming ${mobileClass}`}
    >
      {children}
    </div>
  );
};

export default BroadcastStreamingContainer;
